import React from 'react';
import mixpanel, { type OverridedMixpanel } from '#mixpanel';
import { carrotDomain } from 'utils/carrotDomain';
import { MixpanelContext } from './MixpanelContext';

interface MixpanelProviderProps {
  children: React.ReactNode;
  mixpanel?: OverridedMixpanel;
}
export function MixpanelProvider({
  mixpanel: mixpanelFromProps,
  children,
}: MixpanelProviderProps) {
  const client = mixpanelFromProps ?? mixpanel;

  const tokenFromEnv = import.meta.env.VITE_MIXPANEL_TOKEN;
  if (!tokenFromEnv) throw new Error('A Mixpanel token must be provided');

  client.init(tokenFromEnv);
  configureMixpanel(client);

  return (
    <MixpanelContext.Provider value={client}>
      {children}
    </MixpanelContext.Provider>
  );
}

function configureMixpanel(mixpanel: OverridedMixpanel) {
  // Unregister some super properties that can persist incorrectly from the app
  // repo via the Mixpanel cookie
  mixpanel.unregister('site_id');
  mixpanel.unregister('Site Type');
  mixpanel.unregister('site_url');

  // Set up super properties
  const domain = carrotDomain();
  mixpanel.register({
    site_url: `my.${domain}`,
  });
}
